import {
  BillingPeriod,
  PaymentMethod,
  ProductOffering,
  ProductOfferingKinds,
  ProductOfferingPrice,
  ProductSubscription,
  SelectedProductLineItem,
} from '../entities/db-product-offering.model';

const getDefaultProductOfferingPrice = (): ProductOfferingPrice => ({
  id: '1',
  name: 'Monthly',
  billing_period: BillingPeriod.MONTHLY,
  amount: 45,
});

const getDefaultSelectedProductLineItem = (): SelectedProductLineItem => ({
  id: '600',
  price_id: '601',
  quantity: 1,
});

const getDefaultProductOffering = (): ProductOffering => ({
  id: '1',
  name: 'Launch plan',
  description: '$45/month | Up to 1 department',
  kind: ProductOfferingKinds.BASE,
  prices: [
    getProductOfferingPrice({
      id: '1',
      name: 'Yearly',
      billing_period: BillingPeriod.YEARLY,
      amount: 450,
    }),
    getProductOfferingPrice({
      id: '2',
      name: 'Monthly',
      billing_period: BillingPeriod.MONTHLY,
      amount: 45.75,
    }),
  ],
});

const getDefaultProductSubscription = (): ProductSubscription => ({
  subscription_id: '1',
  line_items: [
    getSelectedProductLineItem({ id: '1', price_id: '1' }),
    getSelectedProductLineItem({ id: '2', price_id: '3', quantity: 6 }),
    getSelectedProductLineItem({ id: '3', price_id: '5' }),
    getSelectedProductLineItem({ id: '300', price_id: '301' }),
    getSelectedProductLineItem({ id: '500', price_id: '501' }),
  ],
  default_payment_method: PaymentMethod.CARD,
  last_4_digits: '1234',
});

export const getProductOfferingPrice = (
  productOfferingPrice?: Partial<ProductOfferingPrice>,
): ProductOfferingPrice => ({
  ...getDefaultProductOfferingPrice(),
  ...productOfferingPrice,
});

export const getProductOffering = (
  productOffering?: Partial<ProductOffering>,
): ProductOffering => ({
  ...getDefaultProductOffering(),
  ...productOffering,
});

export const getSelectedProductLineItem = (
  selectedProductLineItem?: Partial<SelectedProductLineItem>,
): SelectedProductLineItem => ({
  ...getDefaultSelectedProductLineItem(),
  ...selectedProductLineItem,
});

export const getProductOfferings = (): ProductOffering[] => [
  getProductOffering(),
  getProductOffering({
    id: '3',
    kind: ProductOfferingKinds.ADDON,
    name: 'Premium Branding',
    prices: [
      getProductOfferingPrice({ id: '5', amount: 1000, billing_period: BillingPeriod.YEARLY }),
      getProductOfferingPrice({ id: '6', amount: 101.67 }),
    ],
  }),
  getProductOffering({
    id: '300',
    kind: ProductOfferingKinds.ADDON,
    name: 'API Access',
    prices: [
      getProductOfferingPrice({ id: '301', amount: 1000, billing_period: BillingPeriod.YEARLY }),
      getProductOfferingPrice({ id: '302', amount: 101.67 }),
    ],
  }),
  getProductOffering({
    id: '500',
    kind: ProductOfferingKinds.ADDON,
    name: 'Training & Support',
    description: 'Choose between advanced and premium support for easier and quick experience',
    prices: [
      getProductOfferingPrice({ id: '501', amount: 2400, billing_period: BillingPeriod.YEARLY }),
      getProductOfferingPrice({ id: '502', amount: 244 }),
    ],
  }),
  getProductOffering({
    id: '2',
    kind: ProductOfferingKinds.ADDON,
    name: 'Recipients Pack',
    description: '',
    prices: [
      getProductOfferingPrice({ id: '3', amount: 80, billing_period: BillingPeriod.YEARLY }),
      getProductOfferingPrice({ id: '4', amount: 8.13 }),
    ],
  }),
];

export const getProductSubscription = (
  productSubscription?: Partial<ProductSubscription>,
): ProductSubscription => ({
  ...getDefaultProductSubscription(),
  ...productSubscription,
});
